<div class="frame-parent">
  <div class="wrap-parent">
    <div class="wrap">
      <div class="title">
        <div class="title1">{{ "your-next-cafler" | translate }}</div>
      </div>
    </div>
    <div class="resumen">
      <div class="title-parent">
        <div class="title">
          <div class="title1">{{ "your-vehicle" | translate }}</div>
        </div>
        <div class="info-parent">
          <div class="info">
            <div class="description">
              <div class="data">{{ "plate" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ summaryData.vehicleData?.licensePlate }}
              </div>
            </div>
          </div>
          <div class="info">
            <div class="description">
              <div class="data">{{ "vehicleType" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ getVehicleTypeLabel(vehicleType) | translate }}
              </div>
            </div>
          </div>
          <div class="info">
            <div class="description">
              <div class="data">{{ "brand" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">{{ summaryData.vehicleData?.brand }}</div>
            </div>
          </div>
          <div class="info">
            <div class="description">
              <div class="data">{{ "model" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">{{ summaryData.vehicleData?.model }}</div>
            </div>
          </div>
          <div class="info">
            <div class="description">
              <div class="data">{{ "fuel" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ getFuelLabel(fuelType) | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-group">
        <div class="title4">
          <div class="title1">{{ "pickup-datetime" | translate }}</div>
        </div>
        <div class="info-parent">
          <div class="info5">
            <div class="description">
              <div class="data">{{ "pickup-day" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">{{ this.pickDay }}</div>
            </div>
          </div>
          <div class="info5">
            <div class="description">
              <div class="data">{{ "pickup-time" | translate }}:</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{
                  "pickup-between"
                    | translate : { start: pickStart, end: pickEnd }
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="this.summaryData.locationInfo?.isSameAddress === true"
        class="title-group"
      >
        <div class="title4">
          <div class="title1">
            {{ "pickup-dropoff-address" | translate }}
          </div>
        </div>
        <div class="info-parent">
          <div class="info7">
            <div class="description">
              <div class="data">{{ "pickup-address" | translate }}</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ this.summaryData.locationInfo?.originAddress }}
              </div>
            </div>
          </div>
          <div class="info7">
            <div class="description">
              <div class="data">{{ "additional-info" | translate }}</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ this.summaryData.locationInfo?.originAddressDetails }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="this.summaryData.locationInfo?.isSameAddress === false">
        <div class="title-group">
          <div class="title4">
            <div class="title1">{{ "pickup-address" | translate }}</div>
          </div>
          <div class="info-parent">
            <div class="info7">
              <div class="description">
                <div class="data">{{ "pickup-address" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.originAddress }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "additional-info" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.originAddressDetails }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-group">
          <div class="title4-v2">
            <div class="title1">{{ "dropoff-address" | translate }}</div>
          </div>
          <div class="info-parent">
            <div class="info7">
              <div class="description">
                <div class="data">{{ "dropoff-address" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.destinationAddress }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "additional-info" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.destinationAddressDetails }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="title-group"
        *ngIf="this.summaryData.locationInfo?.isSameContact === true"
      >
        <div class="title4">
          <div class="title1">
            {{ "pickup-return-contact-vehicle" | translate }}
          </div>
        </div>
        <div class="info-parent">
          <div class="info7">
            <div class="description">
              <div class="data">{{ "first-name" | translate }}</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ this.summaryData.locationInfo?.originContactName }}
              </div>
            </div>
          </div>
          <div class="info7">
            <div class="description">
              <div class="data">{{ "last-name" | translate }}</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ this.summaryData.locationInfo?.originContactLastName }}
              </div>
            </div>
          </div>
          <div class="info7">
            <div class="description">
              <div class="data">{{ "email" | translate }}</div>
            </div>
            <div class="description">
              <div class="parmetro">
                {{ this.summaryData.locationInfo?.originContactEmailAddress }}
              </div>
            </div>
          </div>
          <div class="info7">
            <div class="description">
              <div class="data">{{ "phone-number" | translate }}</div>
            </div>
            <div class="description">
              <div class="parmetro">
                ({{ this.summaryData.locationInfo?.originPhonePrefix }})
                {{ this.summaryData.locationInfo?.originContactPhoneNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="this.summaryData.locationInfo?.isSameContact === false">
        <div class="title-group">
          <div class="title4">
            <div class="title1">{{ "pickup-contact" | translate }}</div>
          </div>
          <div class="info-parent">
            <div class="info7">
              <div class="description">
                <div class="data">{{ "first-name" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.originContactName }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "last-name" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.originContactLastName }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "email" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.originContactEmailAddress }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "phone-number" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  ({{ this.summaryData.locationInfo?.originPhonePrefix }})
                  {{ this.summaryData.locationInfo?.originContactPhoneNumber }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-group">
          <div class="title4-v2">
            <div class="title1">{{ "return-contact" | translate }}</div>
          </div>
          <div class="info-parent">
            <div class="info7">
              <div class="description">
                <div class="data">{{ "first-name" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{ this.summaryData.locationInfo?.destinationContactName }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "last-name" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{
                    this.summaryData.locationInfo?.destinationContactLastName
                  }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "email" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  {{
                    this.summaryData.locationInfo
                      ?.destinationContactEmailAddress
                  }}
                </div>
              </div>
            </div>
            <div class="info7">
              <div class="description">
                <div class="data">{{ "phone-number" | translate }}</div>
              </div>
              <div class="description">
                <div class="parmetro">
                  ({{ this.summaryData.locationInfo?.destinationPhonePrefix }})
                  {{
                    this.summaryData.locationInfo?.destinationContactPhoneNumber
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-parent1">
        <div class="title4">
          <div class="title1">
            {{ "need-additional-instructions" | translate }}
          </div>
        </div>
        <div class="info-wrapper">
          <div class="wrap">
            <div class="title">
              <div class="parmetro-extra-instructions">
                {{ this.summaryData.locationInfo?.extraInstructions || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="desglose">
    <div class="description">
      <div class="title13">{{ "breakdown" | translate }}</div>
    </div>
    <div class="frame-group">
      <div class="instance-parent">
        <div class="frame-container">
          <div class="frame-parent1">
            <div class="services-icons-wrapper">
              <div class="services-icons">
                <img
                  class="transfer-icon"
                  alt=""
                  [src]="summaryData.productInformation?.icon"
                />
              </div>
            </div>
            <div class="label-value-parent">
              <div class="label-value">
                <span *ngIf="isRefueling">
                  {{ fuelLabel | translate }}
                </span>
                <span *ngIf="!isRefueling">
                  {{
                    this.summaryData.productInformation?.product?.title || ""
                      | translate
                  }}
                </span>
              </div>
              <div class="frame-child"></div>
            </div>
          </div>
          <div class="right-column">
            <div class="label-value1">{{ totalOrder }}€</div>
            <div *ngIf="isRefueling" class="label-value-fuel">
              ({{ "supply-exempt-from-iva" | translate }})
            </div>
          </div>
        </div>
        <!-- <div class="right-column">
            <div class="label-value-fuel">(Suplido exento de I.V.A)</div>
        </div> -->
        <div *ngIf="haveExtraProducts" class="frame-container">
          <div *ngFor="let product of extraProducts" class="frame-wrapper">
            <div class="label-value-parent">
              <img
                class="frame-child"
                alt=""
                [src]="'assets/icons/' + product.ProductKey + '.svg'"
                alt="icono"
              />
              <div class="label-value">
                <div *ngIf="isExtraRefueling">
                  {{
                    getFuelTypeText(summaryData.vehicleData?.fuelType!)
                      | translate
                  }}
                </div>
                <div *ngIf="!isExtraRefueling">
                  {{ product.ProductKey | translate }}
                </div>
              </div>
            </div>
            <div class="right-column">
              <div class="label-value-wrapper">
                <div class="label-value1">{{ product.Amount }}€</div>
              </div>
              <div *ngIf="isExtraRefueling" class="label-value-fuel">
                ({{ "supply-exempt-from-iva" | translate }})
              </div>
            </div>
          </div>
        </div>

        <div class="frame-container" *ngFor="let fee of groupFees">
          <div class="frame-wrapper">
            <div class="label-value-parent">
              <div class="label-value">{{ fee.descripcion | translate }}</div>
            </div>
          </div>
          <div class="label-value-wrapper">
            <div class="label-value1">{{ fee.total }}€</div>
          </div>
        </div>
        <div class="frame-container">
          <div class="frame-wrapper">
            <div class="label-value-parent">
              <div class="label-value">IVA (21%)</div>
            </div>
          </div>
          <div class="label-value-wrapper">
            <div class="label-value1">
              {{ this.summaryData.bookingResponse?.TotalOrderTaxAmount }}€
            </div>
          </div>
        </div>
      </div>
      <div class="frame-container">
        <div class="frame-wrapper">
          <div class="label-value-parent">
            <div class="label-value4">{{ "total" | translate }}</div>
            <div class="frame-child"></div>
          </div>
        </div>
        <div class="label-value-wrapper">
          <div class="label-value1">
            {{
              this.summaryData.bookingResponse?.TotalOrderAmount
                | number : "1.2-2"
            }}€
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="legal-text">
    <div class="lorem-ipsum">
      <span>{{ "cancellation-policy" | translate }} </span>
      <span class="poltica-de-cancelacin">
        <span class="span"> </span>
        <a href="https://cafler.com/terminos-y-condiciones/" target="_blank">{{
          "cancellation-policy-link" | translate
        }}</a>
      </span>
    </div>
  </div>
  <form [formGroup]="form">
    <div>
      <div class="checkbox-wrapper">
        <input type="checkbox" formControlName="requirements" />
        <label>
          {{ "compliance-label-1" | translate }}
          <a (click)="openModal()" class="link">
            {{ "compliance-label-2" | translate }}
          </a>
          {{ "compliance-label-3" | translate }}
        </label>
      </div>
    </div>
    <div class="checkbox-wrapper">
      <input type="checkbox" formControlName="terms" />
      <label for="terms" [innerHTML]="'terms-acceptance-label' | translate">
      </label>
    </div>
    <div class="button-group">
      <ng-content select="[left-button]"></ng-content>
      <button
        type="submit"
        (click)="finalOrder()"
        [disabled]="!form.value.requirements || !form.value.terms"
      >
        {{ "go-to-payment" | translate }}
      </button>
    </div>
  </form>
</div>
